// Renders screenplay-formatted sides with a faint diagonal name watermark.
export const SideReader = ({ script, watermarkName, title, pageLabel }) => {
  const wm = (watermarkName || "").toUpperCase();
  const watermarkText = wm ? `${wm}   `.repeat(8) : "";
  return (
    <div
      className="sides-watermark bg-white border border-hairline px-6 py-8 sm:px-12 sm:py-12"
      data-watermark={watermarkText}
      data-testid="side-reader"
    >
      <div className="flex items-center justify-between mb-8 font-mono text-[11px] uppercase tracking-wider text-stone">
        <span>Working Actor — Sides</span>
        <span>{pageLabel || "1."}</span>
      </div>
      {title && <div className="font-mono font-bold uppercase text-ink text-sm mb-6">{title}</div>}
      <div className="screenplay">
        {(script || []).map((el, i) => {
          const t = el.type;
          if (t === "scene") return <p key={i} className="sp-scene">{el.text}</p>;
          if (t === "action") return <p key={i} className="sp-action">{el.text}</p>;
          if (t === "cue") return <p key={i} className="sp-cue">{el.text}</p>;
          if (t === "paren")
            return (
              <p key={i} className="sp-paren">
                {el.text.startsWith("(") ? el.text : `(${el.text})`}
              </p>
            );
          if (t === "dialogue") return <p key={i} className="sp-dialogue">{el.text}</p>;
          if (t === "transition") return <p key={i} className="sp-transition">{el.text}</p>;
          return <p key={i}>&nbsp;</p>;
        })}
      </div>
    </div>
  );
};
